module.exports = __webpack_public_path__ + "static/media/call2.c737855d.png";